module.exports = __webpack_public_path__ + "static/QuickBrush-Web-ab623a4b17411845cd0d717acfa7321b.woff2";